/* istanbul ignore file */
import Home from './Home';

export default Home;
